/* iZi PDP clips: laden bij zichtbaarheid, pauze buiten beeld, respect voor 'minder beweging', pauzeknop per sectie (8 sep 2026) */
(function(){
  var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var paused=false;
  function load(v){ if(!v.dataset.loaded){ if(v.dataset.src){v.src=v.dataset.src;} v.dataset.loaded='1'; } }
  /* Clips pas ophalen als de pagina klaar is: ze mogen niet met de hero om bandbreedte vechten. */
  var gereed=(document.readyState==='complete');
  if(!gereed){
    window.addEventListener('load',function(){
      setTimeout(function(){
        gereed=true;
        document.querySelectorAll('video.izi-clip[data-izi-wacht]').forEach(function(v){ v.removeAttribute('data-izi-wacht'); play(v); });
      },400);
    });
  }
  function play(v){ if(paused||rm)return; if(!gereed){ v.setAttribute('data-izi-wacht','1'); return; } load(v); var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){play(e.target);} else { e.target.pause(); } });},{rootMargin:'80px 0px'}):null;
  function init(){
    document.querySelectorAll('video.izi-clip').forEach(function(v){
      if(v.dataset.iziInit)return; v.dataset.iziInit='1';
      if(rm){ v.removeAttribute('autoplay'); }
      v.addEventListener('click',function(){ if(v.paused){paused=false;play(v);} else {v.pause();} });
      if(io) io.observe(v); else play(v);
    });
    document.querySelectorAll('.izi-pdp[data-clips]').forEach(function(sec){
      if(sec.querySelector('.izi-clipknop'))return;
      var vids=sec.querySelectorAll('video.izi-clip'); if(!vids.length)return;
      var lbl=sec.getAttribute('data-clips-lbl')||'Clips pauzeren', lbl2=sec.getAttribute('data-clips-lbl2')||'Clips afspelen';
      var b=document.createElement('button'); b.type='button'; b.className='izi-clipknop'; b.setAttribute('aria-pressed',rm?'true':'false'); b.textContent=rm?lbl2:lbl;
      b.addEventListener('click',function(){
        var on=b.getAttribute('aria-pressed')==='true';
        if(on){ b.setAttribute('aria-pressed','false'); b.textContent=lbl; paused=false; vids.forEach(function(v){ load(v); var p=v.play(); if(p&&p.catch)p.catch(function(){}); }); }
        else { b.setAttribute('aria-pressed','true'); b.textContent=lbl2; paused=true; vids.forEach(function(v){v.pause();}); }
      });
      var h=sec.querySelector('.izi-h2'); if(h&&h.parentNode){ h.parentNode.insertBefore(b,h.nextSibling); } else { sec.insertBefore(b,sec.firstChild); }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);} else {init();}
  document.addEventListener('shopify:section:load',init);
})();

/* vouwknoppen (tabellen) toegankelijk: knop + aria-expanded */
(function(){
  function init(){
    document.querySelectorAll('[data-fold-btn]').forEach(function(b){
      if(b.dataset.iziInit)return; b.dataset.iziInit='1';
      b.addEventListener('click',function(){
        var open=b.getAttribute('aria-expanded')==='true'; var box=document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded',open?'false':'true'); if(box){ box.classList.toggle('is-open',!open); }
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);} else {init();}
  document.addEventListener('shopify:section:load',init);
})();

/* 9 sep 2026, Iso: veegrijen voorkauwen. Stipjes tonen hoeveel kaarten er zijn, de knop veegt voor.
   De aanwijzing dooft zodra de bezoeker zelf heeft geveegd. */
(function(){
  function init(){
    document.querySelectorAll('.izi-veeg[data-veeg]').forEach(function(bar){
      if(bar.dataset.iziInit)return; bar.dataset.iziInit='1';
      var rij=bar.previousElementSibling;
      while(rij && !rij.classList.contains('izi-grid')){ rij=rij.previousElementSibling; }
      var dots=bar.querySelector('.izi-veeg__dots');
      var knop=bar.querySelector('[data-veeg-next]');
      if(!rij || !dots || !knop){ bar.style.display='none'; return; }
      var kaarten=[].slice.call(rij.children);
      if(kaarten.length<2){ bar.style.display='none'; return; }
      var lblVeeg=bar.getAttribute('data-lbl-veeg')||'Veeg voor meer';
      var lblTerug=bar.getAttribute('data-lbl-terug')||'Terug naar het begin';
      var tekst=knop.querySelector('[data-veeg-tekst]');
      kaarten.forEach(function(k,i){
        var d=document.createElement('button');
        d.type='button'; d.className='izi-veeg__dot';
        d.setAttribute('aria-label',(i+1)+' / '+kaarten.length);
        d.addEventListener('click',function(){ ganaar(k); bar.classList.add('is-gebruikt'); });
        dots.appendChild(d);
      });
      function ganaar(k){
        var x=k.offsetLeft-rij.offsetLeft, voor=rij.scrollLeft;
        try{
          if(rij.scrollTo){ rij.scrollTo({left:x,behavior:'smooth'}); } else { rij.scrollLeft=x; }
        }catch(e){ rij.scrollLeft=x; }
        /* Terugval: vloeiend scrollen botst in sommige browsers met scroll-snap en doet dan niets.
           Blijft de rij staan, dan springen we alsnog. */
        setTimeout(function(){
          if(Math.abs(rij.scrollLeft-voor)<4 && Math.abs(x-voor)>4){ rij.scrollLeft=x; }
          markeer();
        },380);
      }
      function huidig(){
        var mid=rij.scrollLeft+rij.clientWidth/2, best=0, bd=1e9;
        kaarten.forEach(function(k,i){
          var c=k.offsetLeft-rij.offsetLeft+k.offsetWidth/2, d=Math.abs(c-mid);
          if(d<bd){ bd=d; best=i; }
        });
        return best;
      }
      function markeer(){
        var i=huidig();
        var ds=dots.querySelectorAll('.izi-veeg__dot');
        for(var j=0;j<ds.length;j++){ ds[j].setAttribute('aria-current', j===i?'true':'false'); }
        var eind=rij.scrollLeft+rij.clientWidth>=rij.scrollWidth-6;
        bar.classList.toggle('is-eind',eind);
        if(tekst){ tekst.textContent=eind?lblTerug:lblVeeg; }
      }
      knop.addEventListener('click',function(){
        bar.classList.add('is-gebruikt');
        var i=huidig(), n=kaarten[i+1];
        ganaar(n||kaarten[0]);
      });
      var t;
      rij.addEventListener('scroll',function(){
        bar.classList.add('is-gebruikt');
        clearTimeout(t); t=setTimeout(markeer,90);
      },{passive:true});
      markeer();
      if(window.addEventListener){ window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(markeer,150); },{passive:true}); }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);} else {init();}
  document.addEventListener('shopify:section:load',init);
})();

/* ============================================================
   iZi meetlaag (9 sep 2026, Iso): waar haakt de bezoeker af, en waarom.
   Laag 1: hoe ver komt iemand op de pagina (diepste bereikte sectie).
   Laag 2: wat doet iemand wel en niet (variant, tabel, vraag, koopknop, dode tik).
   Laag 3: een enkele vraag aan wie niets in de wagen legt.
   Verstuurt naar dataLayer en gtag; geen eigen server, geen persoonsgegevens.
   ============================================================ */
/* Gedeelde verzendfunctie: alle iZi-metingen lopen hierlangs. Geen eigen server,
   geen persoonsgegevens, alleen dataLayer en gtag. */
window.iziStuur = window.iziStuur || function(naam, data){
  data = data || {};
  data.event = naam;
  try{ window.dataLayer = window.dataLayer || []; window.dataLayer.push(data); }catch(e){}
  try{ if(typeof window.gtag === 'function'){ var d = {}; for(var k in data){ if(k !== 'event') d[k] = data[k]; } window.gtag('event', naam, d); } }catch(e){}
  /* Antwoorden die wij zelf terug moeten kunnen lezen gaan ook naar Klaviyo, dat toch al
     op elke pagina draait. Alleen de vier gebeurtenissen hieronder, en zonder persoonsgegevens:
     Klaviyo koppelt ze aan het anonieme bezoekersprofiel dat het zelf al bijhoudt. */
  try{
    /* Ook de vergelijking zelf moet leesbaar blijven, anders kunnen we nooit vaststellen
       of de vraag bestellingen kost. izi_vraag_moment en izi_koopknop dragen de groep mee,
       izi_cart_afrekenen doet dat voor de winkelwagen. */
    var bewaren = {izi_afhaakreden:1, izi_afhaakreden_open:1, izi_cartvraag_reden:1, izi_zoekopdracht:1,
                   izi_vraag_moment:1, izi_koopknop:1, izi_cartvraag_moment:1, izi_cart_afrekenen:1,
                   izi_vraag_vertrek_snel:1, izi_vraag_weggeklikt:1};
    if(bewaren[naam] && window.klaviyo){
      var kd = {}; for(var k2 in data){ if(k2 !== 'event') kd[k2] = data[k2]; }
      if(typeof window.klaviyo.push === 'function'){ window.klaviyo.push(['track', naam, kd]); }
      else if(typeof window.klaviyo.track === 'function'){ window.klaviyo.track(naam, kd); }
    }
  }catch(e){}
};

/* ---- Zoekmeting: draait op de zoekpagina, niet alleen op productpagina's ----
   Wat zoeken mensen bij ons, hoeveel vinden ze, en klikken ze door of vertrekken ze.
   Zoekopdrachten zonder resultaat zijn de waardevolste: dat is vraag die wij niet bedienen. */
(function(){
  var z = window.iziZoek;
  if(!z || !z.term) return;
  var term = String(z.term).trim().toLowerCase().slice(0,80);
  if(!term) return;
  var aantal = parseInt(z.aantal, 10) || 0;
  var taalz = document.documentElement.lang || 'nl';
  window.iziStuur('izi_zoekopdracht', {term:term, resultaten:aantal, zonder_resultaat: aantal === 0 ? 1 : 0, taal:taalz});
  var geklikt = false;
  document.addEventListener('click', function(ev){
    if(geklikt || !ev.target || !ev.target.closest) return;
    var a = ev.target.closest('a[href*="/products/"], a[href*="/collections/"]');
    if(!a) return;
    geklikt = true;
    window.iziStuur('izi_zoek_doorklik', {term:term, resultaten:aantal, taal:taalz, naar:(a.getAttribute('href')||'').split('?')[0].slice(0,80)});
  }, true);
  window.addEventListener('pagehide', function(){
    if(!geklikt) window.iziStuur('izi_zoek_zonder_doorklik', {term:term, resultaten:aantal, taal:taalz});
  });
})();

(function(){
  if(!document.querySelector('.izi-pdp')) return;

  var CONFIG = {
    vraagAan: false,       /* laag 3 aan of uit. 12 sep 2026 UIT gezet op verzoek van Iso.
                              De vraag verdwijnt, alle meting blijft gewoon draaien.
                              Weer aan: zet dit terug op true. */
    vraagNaSec: 35,        /* minimaal zoveel seconden op de pagina */
    vraagNaScroll: 25,     /* en minstens zoveel procent gescrold, dus voorbij de koopknop.
                              9 sep 2026 van 45 naar 25: met 45 kwam de vraag maar 4 keer op een dag
                              in beeld tegenover 48 klikken op de koopknop. */
    stilSec: 8,            /* en daarna zoveel seconden niets gedaan: geen scroll, geen tik.
                              9 sep 2026 van 18 naar 8: wie weggaat blijft geen 18 seconden stilzitten,
                              dus juist de snelle afhakers zag je nooit. */
    stilleGroep: 0.2       /* dit deel van de bezoekers krijgt de vraag NOOIT te zien, maar wordt
                              wel op hetzelfde moment geteld. Zo zie je zwart op wit wat de vraag
                              kost of oplevert: leggen mensen mét vraag minder in de wagen dan
                              mensen zonder? Zet op 0 om iedereen de vraag te tonen. */
  };

  var stuur = window.iziStuur;

  var pad = (location.pathname || '').split('/products/')[1] || location.pathname;
  var taal = document.documentElement.lang || 'nl';

  /* ---- Laag 1: diepste bereikte sectie ---- */
  var secties = [].slice.call(document.querySelectorAll('.izi-pdp-section, .shopify-section'));
  var diepste = 0, diepsteNaam = '';
  if('IntersectionObserver' in window && secties.length){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var i = secties.indexOf(e.target);
        if(i > diepste){
          diepste = i;
          var h = e.target.querySelector('h2');
          diepsteNaam = h ? (h.textContent || '').trim().slice(0,60) : (e.target.id || '').slice(0,60);
        }
      });
    },{threshold:0.4});
    secties.forEach(function(s){ io.observe(s); });
  }

  /* ---- Laag 2: gedrag ---- */
  var start = Date.now(), interacties = 0, inWagen = false;
  function tel(naam, extra){
    interacties++;
    var d = {product:pad, taal:taal};
    for(var k in (extra||{})) d[k] = extra[k];
    stuur(naam, d);
  }

  document.addEventListener('click', function(ev){
    var t = ev.target;
    if(!t || !t.closest) return;

    var variant = t.closest('.izi-tier, [data-slimste], variant-radios label, .product-form__input label');
    if(variant){ tel('izi_variant_gekozen', {keuze:(variant.textContent||'').trim().replace(/\s+/g,' ').slice(0,60)}); return; }

    if(t.closest('[data-fold-btn]')){ tel('izi_tabel_open'); return; }
    if(t.closest('[data-veeg-next], .izi-veeg__dot')){ tel('izi_veeg_knop'); return; }
    if(t.closest('.izi-clipknop')){ tel('izi_clip_knop'); return; }

    var vraag = t.closest('.izi-acc summary, summary');
    if(vraag){ tel('izi_vraag_geopend', {vraag:(vraag.textContent||'').trim().replace(/\s+/g,' ').slice(0,80)}); return; }

    var koop = t.closest('[name="add"], .product-form__submit, .izi-koop a, .izi-sticky button, .izi-sticky a');
    if(koop){ inWagen = true; tel('izi_koopknop', {seconden:Math.round((Date.now()-start)/1000), groep:groep, vraag_gezien:getoond?1:0}); return; }

    /* dode tik: binnen de nieuwe secties, maar niets klikbaars geraakt */
    if(t.closest('.izi-pdp') && !t.closest('a,button,summary,label,input,select,textarea,[role="button"],video')){
      var b = t.closest('.izi-card, .izi-step, .izi-pack, .izi-stat');
      if(b){ tel('izi_dode_tik', {blok:(b.querySelector('b') ? b.querySelector('b').textContent : '').trim().slice(0,50)}); }
    }
  }, true);

  /* ---- Laag 1 versturen bij vertrek ---- */
  var verstuurd = false;
  function afsluiten(){
    if(verstuurd) return; verstuurd = true;
    stuur('izi_pagina_diepte', {
      product: pad, taal: taal,
      diepste_sectie: diepste + 1,
      totaal_secties: secties.length,
      diepste_kop: diepsteNaam,
      procent: secties.length ? Math.round((diepste+1)/secties.length*100) : 0,
      seconden: Math.round((Date.now()-start)/1000),
      interacties: interacties,
      in_wagen: inWagen ? 1 : 0,
      groep: groep,
      vraag_gezien: getoond ? 1 : 0
    });
  }
  document.addEventListener('visibilitychange', function(){ if(document.visibilityState === 'hidden') afsluiten(); });
  window.addEventListener('pagehide', afsluiten);

  /* ---- Laag 3: de vraag ---- */
  if(!CONFIG.vraagAan) return;
  var T = {
    nl:{kop:'Eén korte vraag: wat kunnen we op deze pagina beter doen?', opties:['Ik mis informatie','Ik weet niet welke ik moet kiezen','Ik vind de prijs te hoog','Ik twijfel of het doet wat ik zoek','Niets, ik kijk alleen even rond'], anders:'Wat mis je? Eén zin is genoeg', verstuur:'Versturen', dank:'Dank je wel, daar maken we de pagina beter mee.', sluit:'Sluiten'},
    de:{kop:'Eine kurze Frage: Was können wir auf dieser Seite besser machen?', opties:['Mir fehlen Infos','Ich weiß nicht, welche Variante passt','Der Preis ist mir zu hoch','Ich bin unsicher, ob es zu mir passt','Nichts, ich schaue mich nur um'], anders:'Was fehlt dir? Ein Satz reicht', verstuur:'Absenden', dank:'Danke dir, damit machen wir die Seite besser.', sluit:'Schließen'},
    en:{kop:'One quick question: what could we do better on this page?', opties:['Some information is missing','I don’t know which one to pick','The price is too high for me','I’m not sure it does what I need','Nothing, I’m just browsing'], anders:'What is missing? One sentence is enough', verstuur:'Send', dank:'Thank you, that helps us make this page better.', sluit:'Close'},
    fr:{kop:'Une petite question : qu’est-ce qu’on peut améliorer sur cette page ?', opties:['Il me manque des informations','Je ne sais pas quoi choisir','Je trouve le prix trop élevé','Je doute que ça corresponde à mon besoin','Rien, je regarde juste'], anders:'Qu’est-ce qui te manque ? Une phrase suffit', verstuur:'Envoyer', dank:'Merci, ça nous aide à améliorer la page.', sluit:'Fermer'},
    es:{kop:'Una pregunta rápida: ¿qué podemos mejorar en esta página?', opties:['Me falta información','No sé cuál elegir','El precio me parece demasiado alto','Dudo que sea lo que busco','Nada, solo estoy mirando'], anders:'¿Qué te falta? Con una frase basta', verstuur:'Enviar', dank:'Gracias, así mejoramos la página.', sluit:'Cerrar'}
  };
  var t = T[taal.slice(0,2)] || T.nl;
  var SLEUTEL = 'izi_vraag_gehad';
  try{ if(localStorage.getItem(SLEUTEL)) return; }catch(e){}

  var maxScroll = 0;
  window.addEventListener('scroll', function(){
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if(h > 0) maxScroll = Math.max(maxScroll, Math.round(window.scrollY / h * 100));
  }, {passive:true});

  /* Wanneer vragen we?
     Niet blind na een aantal seconden, want dan onderbreek je iemand die nog aan het lezen is.
     Wel als drie dingen samenvallen: lang genoeg op de pagina, voorbij de koopknop gescrold,
     en daarna een tijd niets meer gedaan. Dat is iemand die stilstaat, niet iemand die bezig is.
     Verlaatintentie via de muis is bewust niet gebruikt: 80 procent van het verkeer is mobiel
     en heeft geen muis. */
  var laatsteActie = Date.now();
  ['scroll','touchstart','click','keydown'].forEach(function(ev){
    window.addEventListener(ev, function(){ laatsteActie = Date.now(); }, {passive:true});
  });

  /* Meelopende controlegroep. Een vast deel van de bezoekers krijgt de vraag niet te zien,
     maar wordt op precies hetzelfde moment geteld. Het verschil in winkelwagens tussen beide
     groepen is de werkelijke prijs van de vraag. De indeling blijft per bezoek gelijk. */
  var GROEPSLEUTEL = 'izi_vraaggroep';
  var groep;
  try{
    groep = sessionStorage.getItem(GROEPSLEUTEL);
    if(!groep){ groep = (Math.random() < CONFIG.stilleGroep) ? 'stil' : 'vraag'; sessionStorage.setItem(GROEPSLEUTEL, groep); }
  }catch(e){ groep = (Math.random() < CONFIG.stilleGroep) ? 'stil' : 'vraag'; }

  var getoond = false;
  function magNu(){
    if(getoond || inWagen) return false;
    if(document.visibilityState === 'hidden') return false;
    if((Date.now() - start) / 1000 < CONFIG.vraagNaSec) return false;
    if(maxScroll < CONFIG.vraagNaScroll) return false;
    if((Date.now() - laatsteActie) / 1000 < CONFIG.stilSec) return false;
    return true;
  }
  function toon(){
    if(!magNu()) return;
    getoond = true;

    /* Ook de stille groep telt mee, op hetzelfde punt in de trechter. */
    if(groep === 'stil'){
      stuur('izi_vraag_moment', {product:pad, taal:taal, groep:'stil', getoond:0,
        seconden:Math.round((Date.now()-start)/1000), diepste_kop:diepsteNaam});
      return;
    }
    stuur('izi_vraag_moment', {product:pad, taal:taal, groep:'vraag', getoond:1,
      seconden:Math.round((Date.now()-start)/1000), diepste_kop:diepsteNaam});

    /* Vertrekt iemand vlak nadat de vraag verscheen, dan is dat het duidelijkste teken
       dat hij als drempel werd ervaren. */
    var getoondOp = Date.now(), gereageerd = false;
    window.addEventListener('pagehide', function(){
      if(gereageerd) return;
      var na = Math.round((Date.now()-getoondOp)/1000);
      if(na <= 15) stuur('izi_vraag_vertrek_snel', {product:pad, taal:taal, seconden_na_vraag:na});
    });
    var markeerReactie = function(){ gereageerd = true; };
    try{ localStorage.setItem(SLEUTEL,'1'); }catch(e){}

    var box = document.createElement('div');
    box.className = 'izi-vraag';
    box.setAttribute('role','dialog');
    box.setAttribute('aria-label', t.kop);
    var knoppen = t.opties.map(function(o,i){
      return '<button type="button" class="izi-vraag__optie" data-i="'+i+'">'+o+'</button>';
    }).join('');
    box.innerHTML =
      '<button type="button" class="izi-vraag__x" aria-label="'+t.sluit+'">&times;</button>' +
      '<p class="izi-vraag__kop">'+t.kop+'</p>' +
      '<div class="izi-vraag__opties">'+knoppen+'</div>' +
      '<form class="izi-vraag__open" hidden><label class="izi-vraag__lbl" for="izi-vraag-tekst">'+t.anders+'</label>' +
      '<textarea id="izi-vraag-tekst" rows="2" maxlength="200"></textarea>' +
      '<button type="submit" class="izi-vraag__verstuur">'+t.verstuur+'</button></form>' +
      '<p class="izi-vraag__dank" hidden>'+t.dank+'</p>';
    document.body.appendChild(box);
    requestAnimationFrame(function(){ box.classList.add('is-open'); });

    function klaar(){
      box.querySelector('.izi-vraag__opties').hidden = true;
      box.querySelector('.izi-vraag__kop').hidden = true;
      box.querySelector('.izi-vraag__open').hidden = true;
      box.querySelector('.izi-vraag__dank').hidden = false;
      setTimeout(function(){ box.classList.remove('is-open'); setTimeout(function(){ box.remove(); }, 300); }, 2200);
    }

    box.addEventListener('click', function(ev){
      var x = ev.target.closest('.izi-vraag__x');
      if(x){ markeerReactie(); stuur('izi_vraag_weggeklikt', {product:pad, taal:taal, seconden_na_vraag:Math.round((Date.now()-getoondOp)/1000)}); box.classList.remove('is-open'); setTimeout(function(){ box.remove(); },300); return; }
      var o = ev.target.closest('.izi-vraag__optie');
      if(!o) return;
      var i = parseInt(o.getAttribute('data-i'),10);
      markeerReactie();
      stuur('izi_afhaakreden', {product:pad, taal:taal, reden:t.opties[i], reden_nr:i+1, seconden:Math.round((Date.now()-start)/1000), diepste_kop:diepsteNaam});
      /* Alleen bij "ik mis informatie" vragen we door. De laatste optie is de nette uitweg
         voor wie alleen rondkijkt: die krijgt meteen een bedankje, geen vervolgvraag. */
      if(i === 0){
        box.querySelector('.izi-vraag__opties').hidden = true;
        box.querySelector('.izi-vraag__open').hidden = false;
        box.querySelector('#izi-vraag-tekst').focus();
      } else { klaar(); }
    });

    box.querySelector('.izi-vraag__open').addEventListener('submit', function(ev){
      ev.preventDefault();
      var v = (box.querySelector('#izi-vraag-tekst').value || '').trim().slice(0,200);
      if(v) stuur('izi_afhaakreden_open', {product:pad, taal:taal, tekst:v});
      klaar();
    });
  }
  /* elke 3 seconden kijken of het moment daar is; stopt zodra de vraag getoond is */
  var poll = setInterval(function(){
    if(getoond){ clearInterval(poll); return; }
    toon();
  }, 3000);
})();

/* ---- Winkelwagenvraag (9 sep 2026, Iso) ----
   Andere plek, andere vraag. Op de productpagina gaat het over de pagina zelf;
   hier heeft iemand al gekozen en haakt af op iets praktisch: verzendkosten,
   betaalmethode, levertijd of twijfel over de keuze.
   Bewust terughoudender dan de vraag op de productpagina: een smalle balk onderaan,
   en hij verdwijnt bij de eerste de beste aanraking. Dit is de gevoeligste plek
   van de winkel, dus liever een gemiste meting dan een gemiste bestelling. */
(function(){
  /* 12 sep 2026: winkelwagenvraag UIT gezet op verzoek van Iso, tot nader besluit.
     Weer aan: zet CARTVRAAG_AAN op true. */
  var CARTVRAAG_AAN = false;
  if(!CARTVRAAG_AAN) return;
  var c = window.iziCart;
  if(!c || !c.items) return;

  var NA_SEC = 25;
  var STILLE_GROEP = 0.2;   /* dit deel ziet de balk nooit, maar telt wel mee als vergelijking */
  var taalc = (document.documentElement.lang || 'nl').slice(0,2);
  var T = {
    nl:{kop:'Kunnen we je ergens mee helpen?', opties:['De verzendkosten','Ik zoek een andere betaalmanier','Wanneer het geleverd wordt','Ik twijfel over mijn keuze','Niets, ik reken zo af'], dank:'Dank je wel.', sluit:'Sluiten'},
    de:{kop:'Können wir dir bei etwas helfen?', opties:['Die Versandkosten','Ich suche eine andere Zahlungsart','Wann es geliefert wird','Ich bin unsicher bei meiner Wahl','Nichts, ich bestelle gleich'], dank:'Danke dir.', sluit:'Schließen'},
    en:{kop:'Can we help you with anything?', opties:['The shipping cost','I am looking for another payment method','When it will arrive','I am unsure about my choice','Nothing, I am about to order'], dank:'Thank you.', sluit:'Close'},
    fr:{kop:'On peut t’aider sur quelque chose ?', opties:['Les frais de livraison','Je cherche un autre moyen de paiement','La date de livraison','J’hésite sur mon choix','Rien, je commande tout de suite'], dank:'Merci.', sluit:'Fermer'},
    es:{kop:'¿Te podemos ayudar en algo?', opties:['Los gastos de envío','Busco otra forma de pago','Cuándo llega el pedido','Dudo sobre lo que he elegido','Nada, ahora hago el pedido'], dank:'Gracias.', sluit:'Cerrar'}
  };
  var t = T[taalc] || T.nl;

  var SLEUTEL = 'izi_cartvraag_gehad';
  try{ if(sessionStorage.getItem(SLEUTEL)) return; }catch(e){}

  /* Zelfde opzet als op de productpagina: een vast deel ziet de balk niet, maar wordt op
     hetzelfde moment geteld. Zo weet je of de vraag in de winkelwagen bestellingen kost. */
  var CGROEP;
  try{
    CGROEP = sessionStorage.getItem('izi_cartgroep');
    if(!CGROEP){ CGROEP = (Math.random() < STILLE_GROEP) ? 'stil' : 'vraag'; sessionStorage.setItem('izi_cartgroep', CGROEP); }
  }catch(e){ CGROEP = (Math.random() < STILLE_GROEP) ? 'stil' : 'vraag'; }

  var start = Date.now(), weg = false, getoond = false;

  /* Wie doorklikt naar afrekenen wordt geteld met zijn groep erbij, dat is de vergelijking. */
  document.addEventListener('click', function(ev){
    var t3 = ev.target;
    if(t3 && t3.closest && t3.closest('[name="checkout"], [href*="/checkout"], .cart__checkout-button')){
      window.iziStuur('izi_cart_afrekenen', {groep:CGROEP, balk_gezien:getoond?1:0, artikelen:c.items, waarde:c.total, taal:taalc});
    }
  }, true);

  /* Wie doorklikt naar afrekenen krijgt niets meer te zien */
  document.addEventListener('click', function(ev){
    var t2 = ev.target;
    if(t2 && t2.closest && t2.closest('[name="checkout"], [href*="/checkout"], .cart__checkout-button, form[action*="/cart"] [type="submit"]')) weg = true;
  }, true);

  function verwijder(bar){
    if(!bar) return;
    bar.classList.remove('is-open');
    setTimeout(function(){ if(bar.parentNode) bar.remove(); }, 260);
  }

  function toon(){
    if(getoond || weg || document.visibilityState === 'hidden') return;
    getoond = true;
    try{ sessionStorage.setItem(SLEUTEL,'1'); }catch(e){}

    window.iziStuur('izi_cartvraag_moment', {groep:CGROEP, getoond: CGROEP==='stil'?0:1, artikelen:c.items, waarde:c.total, taal:taalc});
    if(CGROEP === 'stil') return;

    var bar = document.createElement('div');
    bar.className = 'izi-cartvraag';
    bar.setAttribute('role','dialog');
    bar.setAttribute('aria-label', t.kop);
    bar.innerHTML =
      '<button type="button" class="izi-cartvraag__x" aria-label="'+t.sluit+'">&times;</button>' +
      '<p class="izi-cartvraag__kop">'+t.kop+'</p>' +
      '<div class="izi-cartvraag__opties">' +
      t.opties.map(function(o,i){ return '<button type="button" class="izi-cartvraag__optie" data-i="'+i+'">'+o+'</button>'; }).join('') +
      '</div><p class="izi-cartvraag__dank" hidden>'+t.dank+'</p>';
    document.body.appendChild(bar);
    requestAnimationFrame(function(){ bar.classList.add('is-open'); });

    bar.addEventListener('click', function(ev){
      if(ev.target.closest('.izi-cartvraag__x')){
        window.iziStuur('izi_cartvraag_weggeklikt', {artikelen:c.items, waarde:c.total, taal:taalc});
        verwijder(bar); return;
      }
      var o = ev.target.closest('.izi-cartvraag__optie');
      if(!o) return;
      var i = parseInt(o.getAttribute('data-i'),10);
      window.iziStuur('izi_cartvraag_reden', {reden:t.opties[i], reden_nr:i+1, artikelen:c.items, waarde:c.total, taal:taalc, seconden:Math.round((Date.now()-start)/1000)});
      bar.querySelector('.izi-cartvraag__opties').hidden = true;
      bar.querySelector('.izi-cartvraag__kop').hidden = true;
      bar.querySelector('.izi-cartvraag__dank').hidden = false;
      setTimeout(function(){ verwijder(bar); }, 1800);
    });

    /* Meteen weg bij de eerste aanraking BUITEN de balk: hier gaat bestellen voor meten.
       Aanrakingen binnen de balk tellen niet mee, anders verdwijnt hij op het moment
       dat iemand een antwoord wil aantikken. */
    var soorten = ['touchstart','mousedown','scroll','keydown'];
    function buitenaf(e){
      if(e && e.target && bar.contains(e.target)) return;
      soorten.forEach(function(ev){ window.removeEventListener(ev, buitenaf, true); });
      verwijder(bar);
    }
    soorten.forEach(function(ev){ window.addEventListener(ev, buitenaf, true); });
  }

  setTimeout(toon, NA_SEC * 1000);
})();
